import { ReactNode } from 'react'
import { Response } from 'request-dot-js'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

export const handleErrorResponseWithMessage =
  (messageText: string | ReactNode = 'Something went wrong, please try again later.') =>
  <T>(response?: Response<T> | null) => {
    if (response && response.type !== 'success') {
      showToastMessage(messageText, 'error')
    }

    return response
  }
